import {Utilities} from '@shared/utilities/utilities.model';
import {CarShapeModel} from './car-shape.model';
import {
	AdditionalServices,
	DossierAndWorkingStates,
	DossierWorkingWoe,
	MaintenanceTypes,
	ReplacementVehicleDuration,
	ReplacementVehicles,
	WorkingTypes
} from './enums.model';
import {VehicleEquipmentModel} from './vehicle-equipment.model';
import {VehicleAccessoriesModel} from './vehicle-accessories.model';
import {AuthorityAttachment} from './attachment.model';
import {CarbodyWorkingItemsModel} from './carbody-working-items.model';
import {AdministrationWorkingItemsModel} from './administration-working-items.model';
import {MechanicWorkingItemsModel} from './mechanic-working-items.model';
import { EWorkingStates } from './dossier-working.model';
import { BlobTypes } from '@app/shared/models/attached-file.model';

export interface DossierTotal {
	dossier: {
		with_vat: number,
		no_vat: number
	};
	workings: {
		label: WorkingTypes,
		value: {
			with_vat: number,
			no_vat: number
		}
	}[];
}

// l'interfaccia è scomoda da usare
// non si riesce ad assegnare sui singoli campi
export class DossierTotalModel implements DossierTotal {
	dossier: {
		with_vat: number,
		no_vat: number
	};
	workings: {
		label: WorkingTypes,
		value: {
			with_vat: number,
			no_vat: number
		}
	}[];

	constructor(model?: DossierTotal) {

		if (Utilities.isEmpty(model)) {
			this.dossier = {
				with_vat : 0,
				no_vat	 : 0,
			};
			this.workings = [];
			return;
		}

		this.dossier = model.dossier;
		this.workings = model.workings;
	}

	setDossier(no_vat: number, with_vat: number): void {
		this.dossier.no_vat   = no_vat;
		this.dossier.with_vat = with_vat;
	}

	setWorkings(arr: DossierTotalModel['workings']): void {
		this.workings = arr;
	}
}

export class DossierModel {
	acceptingData: AcceptingData;
	acceptingDataCommodityId: string;
	additionalServices: AdditionalServices[];
	brand: string;
	chassis: string;
	contractExpirationDate: string;
	contractId: string;
	customerId: string;
	customerTradingName: string;
	customerVatNumber: string;
	customerAddress: string;
	deliveryDatePrediction: string;
	driverFirstName: string;
	driverId: string;
	driverLastName: string;
	// nome ridondante
	dossierNumber: string;
	dossierNumberPrefix: string;
	
	// TODO
	// flowType dovrebbe essere un enum
	// da testare
	// flowType: DossierFlowType;
	flowType: string;

	// TODO
	// inserire un metodo hasFlowType
	// per non inserire codice ridondante in tutti i component
	
	fuelType: string;
	id: string;
	isCustomerBlackList: boolean;
	kw: string;
	lastRevisionDate: string;
	maintenance_service_type: string; // Possibli valori: null, PPU, FEE(Quota Canone)
	maintenanceType: MaintenanceTypes;
	model: string;
	parentAldCommodityId: string;
	plate: string;
	priority: number;
	replacementVehicle: ReplacementVehicles;
	replacementVehicleDuration: ReplacementVehicleDuration;
	scope: DossierScope[];

	// TODO
	// andrebbe sostituita con una solo per gli interventi
	status: DossierAndWorkingStates;
	
	// TODO
	// inserire un metodo hasStatus
	// per non inserire codice ridondante in tutti i component

	transmission: string;
	vehicleType: VehicleTypes;
	warrantyActive: boolean;
	actions: {
		can_be_accepted: boolean,
		can_be_created_administration_working: boolean,
		can_be_created_carbody_working: boolean,
		can_be_created_mechanic_working: boolean,
		can_be_delivered: boolean,
		can_be_started_delivering: boolean,
		can_be_deleted: boolean,
	};
	attachments: AuthorityAttachment[];
	nature: AuthorityAttachment[];

	total: DossierTotal;
	dossierWorkingQualification: DossierWorkingWoe;
	NBV: number;
	appointment_km: number;

	//repair fields
	name: string;
	phone: string;
	email: string;
	insuranceCompany: string;
	licensePlate: string;

	appointentId: string;
	createdAt: string;
	// causalType: string;
	linked_to_workings: boolean;
	automatically_closed_at: string;
	automatically_closure_days_limit: number;
	is_suspended_technical_stop: boolean;
	private stop_and_go_id: string;
	pnr_id: string;
	to_archive: boolean;
	archived: boolean;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			if (!Utilities.isVoid(model.accepting_data)) {
				this.acceptingData = new AcceptingData(model.accepting_data);
			}
			this.archived = model.archived;
			this.to_archive = model.to_archive;
			this.acceptingDataCommodityId = model.accepting_data_commodity_id;
			this.additionalServices = model.additional_services;
			// this.additionalServices = [AdditionalServices.MECHANIC_PICK_UP, AdditionalServices.CARBODY_PICK_UP, AdditionalServices.TYRE_PICK_UP, AdditionalServices.WASHING];
			this.brand = model.brand;
			this.chassis = model.chassis;
			this.contractExpirationDate = model.contract_expiration_date;
			this.contractId = model.contract_id;
			this.customerId = model.customer_id;
			this.customerTradingName = model.customer_trading_name;
			this.customerVatNumber = model.customer_vat_number;
			this.customerAddress = model.customer_address;
			this.deliveryDatePrediction = model.delivery_date_prediction;
			this.driverFirstName = model.driver_first_name;
			this.driverId = model.driver_id;
			this.driverLastName = model.driver_last_name;
			this.dossierNumber = model.dossier_number;
			this.dossierNumberPrefix = model.dossier_number_prefix;
			this.flowType = model.flow_type;
			this.fuelType = model.fuel_type;
			this.id = model.id;
			this.isCustomerBlackList = model.is_customer_black_list;
			this.kw = model.kw;
			this.lastRevisionDate = model.last_revision_date;
			this.maintenanceType = model.maintenance_type;
			this.maintenance_service_type = model.maintenance_service_type;
			this.model = model.model;
			this.parentAldCommodityId = model.parent_ald_commodity_id;
			this.plate = model.plate;
			this.priority = model.priority;
			this.replacementVehicle = model.replacement_vehicle;
			this.replacementVehicleDuration = model.replacement_vehicle_duration;
			this.scope = [];
			if (!Utilities.isEmpty(model.scope)) {
				model.scope.forEach(scope => this.scope.push(new DossierScope(scope)));
			}
			this.status = model.status;
			this.transmission = model.transmission;
			this.total = model.total;
			this.vehicleType = model.vehicle_type;
			this.warrantyActive = model.warranty_active;
			this.actions = model.actions;
			this.attachments = !Utilities.isVoid(model.attachments) ? model.attachments.map(attachment => new AuthorityAttachment(attachment)) : [];
			this.appointment_km = model.appointment_km;
			// this.causalType = model.causal_type;
			this.dossierWorkingQualification = model.dossier_working_qualification;

			//repair fields
			this.name = model.name;
			this.phone = model.phone;
			this.email = model.email;
			this.insuranceCompany = model.insurance_company;
			this.licensePlate = model.license_plate;
			this.appointentId = model.appointment_id;
			this.createdAt = model.created_at;
			this.NBV = model.net_book_value;
			this.linked_to_workings = model.linked_to_workings;
			this.automatically_closed_at = model.automatically_closed_at;
			this.automatically_closure_days_limit = model.automatically_closure_days_limit;
			this.is_suspended_technical_stop = model.is_suspended_technical_stop;
			this.stop_and_go_id = model.stop_and_go_id;
			this.pnr_id = model.pnr_id;
		}
	}

	// TODO
	// da cancellare, è meglio isMobility()
	getStopAndGoID(): string {
		return this.stop_and_go_id;
	}

	/**
	 * Indica se l'intervento è stato creato da mobility Leaseplan
	 * @returns {boolean}
	 */
	isMobility(): boolean {
		return !!this.stop_and_go_id;
	}

	setArchived(archived: boolean): void {
		this.archived = archived;
	}

	/**
	 * Indica se l'intervento è chiuso-archiviato
	 * Le pratiche associate all'intervento archiviato non possono essere canalizzate
	 * 
	 * @returns {boolean}
	 */
	isArchived(): boolean {
		// return true;
		return !!this.archived;
	}

	/**
	 * Restituisce la lista degli stati finali dell'entità
	 * 
	 * @returns {DossierAndWorkingStates[]}
	 */
	static getFinalStatusList(): DossierAndWorkingStates[] {
		return [ DossierAndWorkingStates.CLOSED ];
	}
	
	/**
	 * Condizione per far partire l'accettazione della pratica
	 * 
	 * @returns {boolean}
	 */
	canDoAcceptance(): boolean {
		return this.status !== 'DELIVERING' && this.actions.can_be_accepted;
	}
	
	/**
	 * Verifica se è stato firmato il documento di accettazione
	 * nel processo è presente la firma digitale
	 * 
	 * @param {boolean} isCenterOperator
	 * @returns {boolean}
	 */
	isAcceptanceSignEnabled(isCenterOperator: boolean): boolean {

		// PROCESSO DI ACCETTAZIONE CONCLUSO LATO MOBILITY
		// evita di far uscire il messaggio di errore 

		// SPIEGAZIONE:
		// su authority non c'è firma digitale ma solo cartacea e funziona così:	
		//   1) compilano modale accettazione
		//   2) scaricato il documento compilato
		//   3) lo firmano cartaceo, scannerizzano e caricano su nemo authority 
	  // (col flusso mobility 2 e 3 non stanno su nemo)
		// (lato authority il check del documento caricato fallisce perché sta lato mobility)
 
		if (this.isMobility()) {
			return false;
		}

		return (
			isCenterOperator &&
			!this.canDoAcceptance() &&
			this.acceptingData && this.acceptingData.createdAt && 
			(!this.attachments || !this.attachments.some(a => a.blobType === BlobTypes.ACCEPTANCE_REPORT))
		);
	}
}

// TODO
// andrebbe tolta e il riferimento 
// va sostituito con DossierWorking
export class DossierScope {
	category: WorkingTypes;
	color: string;

	// tipologia da sostituire con EWorkingStates
	status: string;
	firstApprovedAt: string;
	
	// Controlla se la pratica dev'essere da ri-approvare
	// (es: il centro assistenza aggiunge un ricambio in fase di integrazione)
	isReApproved? : boolean = false;

	constructor(model?: any) {
		if (!Utilities.isVoid(model)) {
			this.category = model.category;
			this.color = model.color;
			this.status = model.status;
			this.firstApprovedAt = model.first_approved_at;
			
			this.isReApproved = model.first_approved_at != null && model.status === EWorkingStates.APPROVING;
		}
	}
}

export class AcceptingData {
	booklet: boolean;
	keys: boolean;
	doubleKeys: boolean;
	marching: boolean;
	rolling: boolean;
	fire: boolean;
	frontPlate: boolean;
	rearPlate: boolean;
	acceptingKm: string;
	carShape: CarShapeModel;
	createdAt: string;
	ddtNumber: string;
	email: string;
	expectedDeliveryDate: string;
	firstName: string;
	fuelLevel: string;
	lastName: string;
	phone: string;
	rescueCompany: string;
	carbodyNote: string;
	truckPlate: string;
	saddleryNote: string;
	tiresWearLevel: number;
	carbodyWorkingItems?: CarbodyWorkingItemsModel;
	administrationWorkingItems?: AdministrationWorkingItemsModel;
	mechanicWorkingItems?: MechanicWorkingItemsModel;
	vehicleEquipment: VehicleEquipmentModel;
	vehicleAccessories: VehicleAccessoriesModel;
	fiscalCode: string;
	replacementVehiclePlate: string;

	constructor(model?: ServerAcceptingData) {
		if (!Utilities.isVoid(model)) {
			this.acceptingKm = model.accepting_km;
			if (!Utilities.isVoid(model.car_shape)) {
				this.carShape = new CarShapeModel(model.car_shape);
			}
			this.createdAt = model.created_at;
			this.ddtNumber = model.ddt_number;
			this.email = model.email;
			this.expectedDeliveryDate = model.expected_delivery_date;
			this.firstName = model.first_name;
			this.fuelLevel = model.fuel_level;
			this.lastName = model.last_name;
			this.phone = model.phone;
			this.rescueCompany = model.rescue_company;
			this.truckPlate = model.truck_plate;
			this.carbodyNote = model.carbody_note;
			this.saddleryNote = model.saddlery_note;
			this.tiresWearLevel = model.tires_wear_level;
			this.carbodyWorkingItems = new CarbodyWorkingItemsModel(model.carbody_working_items);
			this.administrationWorkingItems = new AdministrationWorkingItemsModel(model.administration_working_items);
			this.mechanicWorkingItems = new MechanicWorkingItemsModel(model.mechanic_working_items);
			this.vehicleEquipment = new VehicleEquipmentModel(model.vehicle_equipment);
			this.vehicleAccessories = new VehicleAccessoriesModel(model.vehicle_accessories);
			this.fiscalCode = model.fiscal_code;
			this.replacementVehiclePlate = model.replacement_vehicle_plate;
			this.booklet = model.booklet;
			this.keys = model.keys;
			this.doubleKeys = model.double_keys;
			this.marching = model.marching;
			this.rolling = model.rolling;
			this.fire = model.fire;
			this.frontPlate = model.front_plate;
			this.rearPlate = model.rear_plate;
		}
	}
}

export interface ServerAcceptingData {
	rear_plate: boolean;
	front_plate: boolean;
	fire: boolean;
	rolling: boolean;
	marching: boolean;
	double_keys: boolean;
	keys: boolean;
	booklet: boolean;
	accepting_km: any;
	car_shape: any;
	created_at: any;
	ddt_number: any;
	email: any;
	expected_delivery_date: any;
	first_name: any;
	fuel_level: any;
	last_name: any;
	phone: any;
	rescue_company: any;
	truck_plate: any;
	carbody_note: any;
	saddlery_note: any;
	tires_wear_level: any;
	carbody_working_items: any;
	administration_working_items: any;
	mechanic_working_items: any;
	vehicle_equipment: any;
	vehicle_accessories: any;
	fiscal_code: any;
	replacement_vehicle_plate: any;
}

export enum VehicleTypes {
	BIKE = 'BIKE',
	CAR = 'CAR',
	SUV = 'SUV',
	VAN = 'VAN'
}

export class DossierAttachment {

	// private file     : any; 
	private filename : string = '';
	// è il contenuto del file, non sappiamo se sia un base64 o altro
	private content	 : string = '';

	constructor(model?: any) {

		if (Utilities.isEmpty(model)) {
			return;
		}

		this.content	= model.content;
		this.filename	= model.name;
		// TODO
		// creare il file con qualche API (non so se si può fare)
		// esempio createFile(model.file)
	}

	getFilename(): string {
		return this.filename;
	}

	setFilename(filename): void {
		this.filename = filename;
	}

	// getFile(): any {
	// 	return this.file;
	// }

	// setFile(file): void {
	// 	this.file = file;
	// }

	download(): void {
		Utilities.downloadFileFromBase64(this.content, this.filename);
	}
}

export enum EDossierStates {
	TO_ESTIMATE	= 'TO_ESTIMATE',
	WORKING			= 'WORKING',
	DELIVERING	= 'DELIVERING',
	CLOSED			= 'CLOSED',
	
	/**
	 *  Stato finto - non esiste a BE
	 * 	FORSE andrà utilizzato come su carglass, quando selezionato:
	 *  impostare lo stato a CLOSED e to_archive = true
	 *  
	 *  inserito con performance archiviazione
	 *  le pratiche chiuse hanno un periodo di retention
	 *  (30 giorni) in cui rimangono nel DB Attivo.
	 * 	Finito il periodo viene passata nel DB Archivio.
	 */ 
	CLOSED_TO_BE_ARCHIVE = "CLOSED_TO_BE_ARCHIVE",
}
